export const escapeSingleDoubleQuotesAndBackSlash = (input: string): string => {
  // Use a regular expression to find single quotes, double quotes, and backslashes
  const regex = /['"\\]/g;

  // Replace each occurrence with the escaped version
  const output = input.replace(regex, (match) => '\\' + match);

  return `'${output}'`;
};
